import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-contact-footer',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './contact-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contact-footer.component.scss'
})
export class ContactFooterComponent {

}
